<template>
	<page>
		<module>
			<view-list ref="view" work-type="1" selector :view-config="saasInfo.viewmanage">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="账号">
							<c-input name="user_name"></c-input>
						</m-search-item>
						<m-search-item label="姓名">
							<c-input name="user_realname"></c-input>
						</m-search-item>
						<m-search-item label="手机号码">
							<c-input name="phone"></c-input>
						</m-search-item>
						<m-search-item label="部门">
							<c-select name="department_ids" async multiple @search="searchDepartment"></c-select>
						</m-search-item>
						<m-search-item>
							<c-checkbox-group name="state" :options="disableEnableDic"></c-checkbox-group>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
                    <c-button color="main" v-if="auth('b_sysuser_edit')" prepend-icon="tf-add" @click="createUser()">创建用户</c-button>
                    <c-button v-if="auth('b_sysuser_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
<!--                    <c-button v-if="auth('b_sysuser_edit')" prepend-icon="tf-import" @click="$refs.view.excelImport()">导入</c-button>-->
				</template>
				
				<template #batchOperate="{data}">
                    <c-button v-if="auth('b_sysuser_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_sysuser_print')"  prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

<!--				<template #otherOperate>
					<c-button v-if="auth('b_sysuser_log')" prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_sysuser_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>-->

                <!--账号类型-->
                <template #user_type="{data}">
                    <c-state tag dict="userTypeDic" :value="data.user_type"></c-state>
                </template>

				<!--启禁用状态-->
				<template #state="{data}">
					<c-switch v-if="auth('b_sysuser_edit') && data.is_manage != 1 " v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
					<c-state v-else tag dict="disableEnableDic" :value="data.state"></c-state>
				</template>
				
				<!--是否是超级管理员-->
				<template #is_manage="{data}">
					<c-state tag dict="isManageDic" :value="data.is_manage"></c-state>
				</template>
				
				<!--锁定状态-->
				<template #is_lock="{data}">
					<c-state v-if="data.user_type == 1" dict="lockStateDic" :value="data.is_lock"></c-state>
					<span v-else>-</span>
				</template>
				
				<!--部门 -->
				<template #department_names="{data}">
					<span v-if="!data.department_names" >-</span>
					<c-tags v-else :value="data.department_names"></c-tags>
				</template>
                <!--数据权限 -->
                <template #data_scope="{data}">
                    <c-state tag dict="dataScopeDic" :value="data.data_scope"></c-state>
                </template>

                <!--竞价堂账号（仅在视图配置了该列时生效，未绑定显示 - ）-->
                <template #bidding_hall_username="{data}">
                    <span v-if="data.bidding_hall_username">{{ data.bidding_hall_username }}</span>
                    <span v-else>-</span>
                </template>

				<!--锁定状-->
				<template #is_lock_tip="{data}">
					<c-tooltip tip="提示" width="300">
						<template #tip>
							<p>锁定状态说明：</p>
							<p>锁定：登陆账户密码错误次数过多，账户将自动锁定，锁定后将无法使用账号密码方式登陆</p>
							<p>风险解除：风险解除后可正常使用账号密码方式登陆</p>
						</template>
					</c-tooltip>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="250"
					button-limit="6"
				>
					<template #default="{data}">
						<!-- <c-table-button v-if="auth('b_sysuser_edit')" icon="tf-trash" color="red" @click="removeSysuser(data)">删除</c-table-button> -->
						<c-table-button v-if="auth('b_sysuser_edit')" :disabled="(data.is_manage == 1)" icon="tf-reset-password" @click="resetPwd(data)">重置密码</c-table-button>
						<!--当前登录人对自己账号不可编辑、不可配置操作权限/数据权限，故本人行隐藏以下按钮-->
						<c-table-button v-if="auth('b_sysuser_edit') && !isSelf(data)" icon="tf-edit" @click="$refs.sysuserEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_sysuser_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 && !isSelf(data)" icon="tf-auth" @click="$refs.sysuserAuthConfig.open(data, 0)">电脑端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 && !isSelf(data)" icon="tf-auth" @click="$refs.sysuserAuthConfig.open(data, 1)">手机端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 " icon="tf-copy" @click="$refs.sysuserAuthCopy.open(data, 0)">复制电脑端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 " icon="tf-copy" @click="$refs.sysuserAuthCopy.open(data, 1)">复制手机端权限</c-table-button>
						<c-table-button v-if="auth('b_sysuser_edit') && data.is_manage != 1 && !isSelf(data)" icon="tf-data-auth" @click="$refs.sysuserDataScopeEdit.open(data)">数据权限</c-table-button>
						<!-- 竞价堂绑定/解绑：仅在商户开通竞价堂 + 员工账号 + 非超级管理员时可见 -->
						<c-table-button v-if="auth('b_sysuser_bidding') && canBindJldhs(data) && !data.bidding_hall_username" icon="tf-bind" @click="$refs.sysuserBiddingHallBind.open(data)">绑定竞价堂</c-table-button>
						<c-table-button v-if="auth('b_sysuser_bidding') && canBindJldhs(data) && data.bidding_hall_username" icon="tf-unbind" @click="unbindBiddingHall(data)">解绑竞价堂</c-table-button>
						<!-- <c-table-button v-if="auth('b_sysuser_edit')" icon="tf-unbind" :disabled="data.is_lock == 0" @click="riskRemoval(data)">账号解锁</c-table-button> -->
					</template>
				</c-table-column>
			</view-list>
			<!--编辑用户信息弹窗-->
			<sysuser-edit ref="sysuserEdit" @resolve="$refs.view.update()"></sysuser-edit>
			<!--设置用户权限编辑弹窗-->
			<sysuser-auth-config ref="sysuserAuthConfig"  @resolve="$refs.view.update()"></sysuser-auth-config>
			<!--设置用户权限复制弹窗-->
			<sysuser-auth-copy ref="sysuserAuthCopy"></sysuser-auth-copy>
			<!--设置用户数据权限弹窗-->
			<sysuser-data-scope-edit ref="sysuserDataScopeEdit" @resolve="$refs.view.update()"></sysuser-data-scope-edit>
			<!--绑定竞价堂弹窗-->
			<sysuser-bidding-hall-bind ref="sysuserBiddingHallBind" @resolve="$refs.view.update()"></sysuser-bidding-hall-bind>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import sysuserEdit from "@/pages/system/sysuser_edit.vue";
	import sysuserAuthConfig from "@/pages/system/sysuser_auth_config.vue";
	import sysuserAuthCopy from "@/pages/system/sysuser_auth_copy.vue";
	import sysuserDataScopeEdit from "@/pages/system/sysuser_data_scope_edit.vue";
	import sysuserBiddingHallBind from "@/pages/system/sysuser_bidding_hall_bind.vue";
	export default {
		components: {sysuserEdit, sysuserAuthConfig, sysuserAuthCopy, sysuserDataScopeEdit, sysuserBiddingHallBind},
		computed: {
			// 获取dictName选项数据
			...mapState(['disableEnableDic', 'saasInfo', 'userTypeDic', 'pricingTypeDic', 'userInfo']),
		},

		data() {
			return {
				defaultSearchData: {
					'state': [1]
				}
			}
		},

		methods: {
			/******该行是否为当前登录人本人账号：自己账号不允许编辑与配置操作权限*******/
			isSelf(data) {
				return !!this.userInfo && data.id == this.userInfo.id;
			},

			/******新建用户：按当前视图预置账号类型*******/
			createUser() {
				this.$refs.sysuserEdit.open(null, this.defaultUserTypeByView());
			},

			/******按当前视图ID映射新建用户的默认勾选账号类型：20040304员工视图→1，20040305供应商联系人视图→2；其他视图不预置*******/
			defaultUserTypeByView() {
				var viewId = this.$refs.view.getViewId();
				if (viewId == 20040304) return 1;
				if (viewId == 20040305) return 2;
				return null;
			},

			/*******是否允许操作竞价堂绑定：商户已开通竞价堂 + 员工账号 + 非超级管理员 + 编辑权限 *****************/
			canBindJldhs(data){
				return this.saasInfo
					&& this.saasInfo.is_open_jldhs == 1
					&& data.user_type == 1
					&& data.is_manage != 1
					&& this.auth('b_sysuser_edit');
			},

			/*******解绑竞价堂 *****************/
			unbindBiddingHall(data){
				if(!data.bidding_hall_username){
					this.$message({
						message: '员工【'+data.user_realname+'】尚未绑定竞价堂账号',
						type: 'warning'
					});
					return;
				}
				this.$confirm({
					message: '确认解除员工【'+data.user_realname+'】与竞价堂账号【'+data.bidding_hall_username+'】的绑定？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sys_user/unbind_bidding_hall',
							data: {id: data.id},
							loading: true,
							success: (res, message) => {
								this.$message({
									message: message || '解绑成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {},
				});
			},

			/*******搜索部门*****************/
			searchDepartment(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DEPARTMENT',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/******删除用户***********/
			removeSysuser(data){
				this.$confirm({
					message:'确认删除用户【'+data.user_realname+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******重置密码***********/
			resetPwd(data){
				this.$confirm({
					message:'确定重置用户【'+data.user_realname+'】的登录密码？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/reset_pwd',
							data: {id:data.id},
							loading: true,
							success: result => {
								this.$confirm({
									type: 'success',
									message: result,
									buttonName: '知道了',
									cancelButton: false,
									resolve: () => {
									}
								});
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******用户启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/sys_user/update_state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					success: (data, message) => {
						this.$message({
							message: message,  // 提示内容,
							type: 'success'
						});
						next();
					}
				})
			},
			
			/******账号类型切换*********/
			userTypeHandle(user_type, next, data) {
				this.request({
					url: '/sys_user/update_user_type',
					data: {
						id: data.id,
						user_type: user_type ? 2 : 1
					},
					success: (data, message) => {
						this.$message({
							message: message,  // 提示内容,
							type: 'success'
						});
						next();
					}
				})
			},
			
			/******解锁账户***********/
			riskRemoval(item){
				this.$confirm({
					message:'解锁用户【'+item.user_realname+'】为正常状态？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/riskRemovalByUserId',
							data: {
								user_id: item.id
							},
							loading: true,
							success: (data, message) => {
								this.$message({
									message: message,  // 提示内容,
									type: 'success'
								});
								item.is_lock = 0;
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>